export const navList = [
  {
    id: 0,
    title: '首页',
    src: '',
  },
  {
    id: 1,
    title: '前言',
    src: '',
  },
  {
    id: 3,
    title: '爬行动物的演化',
    src: '',
  },
  {
    id: 4,
    title: '具羽毛恐龙的出现',
    src: '',
  },
  {
    id: 5,
    title: '原始基干鸟类',
    src: '',
  },
  {
    id: 6,
    title: '反鸟类',
    src: '',
  },
  {
    id: 7,
    title: '今鸟型类',
    src: '',
  },
]